// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/illustration-template/src/index.tsx

import baseIllustration from '@bubble-ui/temp-illustration-base';
var IllustrationAutopayPath = 'M60.5 0h-21v7h7v14H50c19.882 0 36 16.118 36 36S69.882 93 50 93c-17.419-.092-32.273-12.642-35.272-29.801-2.577-14.743 4.234-29.255 16.576-36.851L29.3 34l6.8 1.7 5-19.3-19.3-5.1-1.8 6.8 7.917 2.074C12.952 29.188 4.661 46.66 7.77 64.415 11.363 84.943 29.16 99.939 50 100a43 43 0 0030.4-73.4 42.4 42.4 0 00-26.9-12.4V7h7V0zm-14 77.3V83h7v-5.8c7-1 11.7-5.5 11.7-11.6 0-9.106-9.992-10.962-14.366-11.775L50.7 53.8c-9.1-1.6-9.1-3.8-9.1-4.9 0-2.9 3.3-4.8 8.1-4.8a17 17 0 0110.4 3.3l4.1-5.6a23.6 23.6 0 00-10.7-4.5V32h-7v5.3c-7.2 1-11.9 5.5-11.9 11.7 0 9 10.4 10.9 14.9 11.7 8.7 1.6 8.7 3.7 8.7 5 0 2.8-3.3 4.8-8.1 4.8a17.5 17.5 0 01-11.4-4.1l-4.6 5.3a25.5 25.5 0 0012.4 5.6z';
var IllustrationAutopay = baseIllustration('IllustrationAutopay', {
  getPath: () => IllustrationAutopayPath
}, 'ColoredIllustrationAutopay');

/**
 * @deprecated this component is outdated and will be removed with v6.0.0
 */
export default IllustrationAutopay;
//# sourceMappingURL=index.js.map